module.exports = __webpack_public_path__ + "media/images/emblems/City_of_Fribourg-coat_of_arms-1d1f5fac253a27e8d46c4e094acb1398.svg";